import { IContractSend } from 'src/types/contract';
import { ContractFormData } from '../../screens/General/screens/Contract/components/ContractForm';

const groupContract = (dataForm: Partial<ContractFormData>): Partial<IContractSend> => {
    const { caseNumberDropDown, languageDropDown, ...data } = dataForm;
    const dataSend: Partial<IContractSend> = { ...data };

    if (caseNumberDropDown) {
        dataSend.caseNumber = caseNumberDropDown.value;
    }
    if (languageDropDown) {
        dataSend.language = languageDropDown.value;
    }
    return dataSend;
};
export { groupContract };
